<template>
  <v-container fluid class="pa-0">
    <v-card class="mr-3 ml-3 mb-3">
      <!--    <v-card-title class="headline">-->
      <!--&lt;!&ndash;      <span class="mr-3">Объекты</span>&ndash;&gt;-->
      <!--      <v-btn class="mr-3" color="green" dark to="/objects/add">-->
      <!--        <v-icon>mdi-plus</v-icon>-->
      <!--        Добавить-->
      <!--      </v-btn>-->
      <!--      <v-btn-->
      <!--          color="green"-->
      <!--          dark-->
      <!--          @click="showingDeleted = !showingDeleted"-->
      <!--      >-->
      <!--        <span v-if="!showingDeleted">Показать удаленные</span>-->
      <!--        <span v-else>Скрыть удаленные</span>-->
      <!--      </v-btn>-->
      <!--      <v-spacer></v-spacer>-->
      <!--      <v-text-field-->
      <!--          v-if="$store.getters.objects"-->
      <!--          v-model="search"-->
      <!--          append-icon="mdi-magnify"-->
      <!--          label="Поиск"-->
      <!--          single-line-->
      <!--          hide-details-->
      <!--      ></v-text-field>-->
      <!--    </v-card-title>-->
      <v-card-title class="headline justify-space-between">
        <div>
          <v-btn
            class="mr-3"
            color="green"
            dark
            to="/objects/add"
            v-if="$store.getters.user.roleId < 2"
          >
            <v-icon>mdi-plus</v-icon>
            Добавить
          </v-btn>
          <v-btn class="mr-3" color="green" dark @click="showingDeleted = !showingDeleted">
            <span v-if="!showingDeleted">Показать удаленные</span>
            <span v-else>Скрыть удаленные</span>
          </v-btn>
          <v-menu v-if="this.$store.getters.user.roleId === 0" class="mr-3" color="green" offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on">
                <v-icon>mdi-file-download</v-icon>
                Выгрузить в файл
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="exportToFile('csv')">csv</v-list-item>
              <v-list-item @click="exportToFile('xlsx')">xlsx</v-list-item>
            </v-list>
          </v-menu>
        </div>

        <div>
          <v-text-field
            v-if="$store.getters.dealers"
            v-model="search"
            append-icon="mdi-magnify"
            label="Поиск"
            single-line
            hide-details
            class="pt-0"
          ></v-text-field>
        </div>
      </v-card-title>

      <v-data-table
        class="mb-3 mx-3"
        :search="search"
        :headers="headers"
        :items="objects"
        :item-class="
          (item) => (item.isDeleted ? 'deleted clickable-row' : 'clickable-row')
        "
        no-data-text="Пусто"
        no-results-text="Результатов нет"
        @click:row="editObject"
        hide-default-footer
        sort-by="id"
        :sort-desc="true"
        :loading="tableLoading"
        loading-text="Загрузка"
        :items-per-page="10"
      >
        <template v-slot:header.id="{ header }">
          <span v-html="header.text"></span>
        </template>

        <template v-slot:item.expires="{ item }">
          <span
            :class="{
              expired:
                new Date() >
                new Date(
                  item.expires.split('.')[2],
                  item.expires.split('.')[1],
                  item.expires.split('.')[0]
                ),
            }"
            >{{ item.expires }}</span
          >
        </template>
        <template v-slot:item.actions="{ item }">
          <v-tooltip v-if="!item.isDeleted" top nudge-bottom="4">
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                @click.stop="deleteObjectConfirm(item)"
                v-bind="attrs"
                v-on="on"
              >
                mdi-delete
              </v-icon>
            </template>
            <span>Удалить</span>
          </v-tooltip>

          <v-tooltip v-else top nudge-bottom="4">
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                @click.stop="restoreObject(item)"
                v-bind="attrs"
                v-on="on"
              >
                mdi-backup-restore
              </v-icon>
            </template>
            <span>Восстановить</span>
          </v-tooltip>
        </template>
        <template v-slot:top="{ pagination, options, updateOptions }">
          <v-data-footer
            :pagination="pagination"
            :options="options"
            @update:options="updateOptions"
            :items-per-page-options="[10, 50, 100, -1]"
            items-per-page-text="$vuetify.dataTable.itemsPerPageText"
          />
        </template>
        <template v-slot:item.updateTime="{ item }">
          <span>{{ formatUpdateTime(item.updateTime) }}</span>
        </template>
      </v-data-table>
    </v-card>

    <confirmation-dialog
      ref="confirmation"
      title="Удаление Объекта"
      agree-button="Удалить"
      disagree-button="Отмена"
      @agree="deleteObject($event)"
    ></confirmation-dialog>
  </v-container>
</template>

<script>
import API from "@/axios/api";
import ConfirmationDialog from "@/components/ConfirmationDialog";

import FormatDateTime from "@/utils/time.js";

export default {
  components: {
    ConfirmationDialog,
  },
  data() {
    return {
      deletingObjectId: "",

      tableLoading: true,
      search: "",
      showingDeleted: false,
      allHeaders: [
        {
          text: "Код <br>объекта",
          align: "start",
          value: "id",
          width: 100
        },
        {
          text: "Название",
          align: "start",
          value: "objectName",
        },
        {
          text: "Дилер",
          align: "start",
          value: "dealerName",
        },
        {
          text: "Город",
          align: "start",
          value: "city",
        },
        {
          text: "Доп. инфо",
          align: "start",
          value: "description",
          sortable: false,
          width: 80
        },
        {
          text: "Email",
          align: "center",
          value: "email",
          sortable: false,
        },
        {
          text: "Изменил",
          align: "center",
          value: "creatorName",
        },
        {
          text: "Дата последнего изменения",
          align: "start",
          value: "updateTime",
        },
        {
          text: "Действия",
          align: "center",
          value: "actions",
          sortable: false,
          superAdminOnly: true,
        },
      ],
    };
  },
  methods: {
    exportToFile(format) {
      const showingDeleted = this.showingDeleted;
      API.get(`objects/reports?format=${format}&showingDeleted=${showingDeleted}`, { responseType: 'blob' })
      .then(response => {
      if (response.status === 200) {
        let contentType = '';
        let fileExtension = '';
        if (format === 'csv') {
          contentType = 'text/csv';
          fileExtension = '.csv';
        } else if (format === 'xlsx') {
          contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
          fileExtension = '.xlsx';
        }
        const blob = new Blob([response.data], { type: contentType });
        const date = new Date();
        const currentDate = this.formatUpdateTime(date); 
        const filename = `Отчет объекты ${currentDate}${fileExtension}`.replace(/:/g, '.');
        if (window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, filename);
        } else {
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
          window.URL.revokeObjectURL(url);
        }
        console.log('Файл успешно загружен');
      } else {
        console.error('Ошибка загрузки файла:', response.statusText);
      }
    })
    .catch(error => {
      console.error('Ошибка загрузки файла:', error);
    });
},

    editObject(object) {
      if (object.isDeleted) {
        this.$store.commit("showSnackbar", {
          color: "warning",
          text: "Объект удален",
        });
      } else {
        this.$router.push("/objects/" + object.id);
      }
    },
    deleteObjectConfirm(object) {
      this.deletingObjectId = object.id;
      this.$refs.confirmation.showDialog(
        object.id,
        `Вы действительно хотите удалить Объект <span class="highlighted">${object.objectName}</span> ?`
      );
    },
    deleteObject(objectId) {
      API.get(`objects/${objectId}/delete`)
        .then((response) => {
          console.log(response.data);
          this.$store.dispatch("updateObjects");
          this.$store.dispatch("updateMasters");
          this.$store.dispatch("updateLicenses");
        })
        .catch((error) => {
          console.log(error);
          if (error.response.data.message)
            this.$store.commit("showSnackbar", {
              color: "error",
              text: error.response.data.message,
            });
        });
    },
    restoreObject(object) {
      API.get(`objects/${object.id}/restore`)
        .then((response) => {
          console.log(response.data);
          this.$store.dispatch("updateObjects");
        })
        .catch((error) => {
          console.log(error);
          if (error.response.data.message)
            this.$store.commit("showSnackbar", {
              color: "error",
              text: error.response.data.message,
            });
        });
    },
    formatUpdateTime(time) {
      return FormatDateTime(time);
    },
  },
  computed: {
    headers() {
      return this.allHeaders.filter(
        (h) => !h.superAdminOnly || this.$store.getters.user.roleId === 0
      );
    },
    objects: function () {
      return this.$store.getters.objects.filter((object) =>
        this.showingDeleted ? true : !object.isDeleted
      );
    },
  },
  activated() {
    this.$store.commit("setCrumbs", [
      { text: "main", disabled: false, to: "/", exact: true },
      { text: "objects", disabled: true },
    ]);
  },
  created() {
    this.$store.dispatch("updateObjects").then(() => {
      this.tableLoading = false;
    });
  },
};
</script>

<style>
.deleted {
  background-color: #e5d4d4;
}

.expired {
  background-color: #eccdcd;
  color: #000000;
  padding: 0.2rem 0.5rem;
  border-radius: 3px;
}
</style>
